import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgLogout = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.41412 12L8.70701 14.2929L7.2928 15.7071L2.58569 11L7.2928 6.29289L8.70701 7.70711L6.41412 10H12.9999V12H6.41412ZM15.9999 18V4H12.9999V2H17.9999V20H12.9999V18H15.9999Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgLogout);

export default ForwardRef;
